import {library} from '@fortawesome/fontawesome-svg-core';
import {
  faStar,
  faCog,
  faAngleUp,
  faShare,
  faHistory,
  faFont,
  faQuestionCircle,
  faUndo,
  faRedo,
  faSyncAlt,
  faExclamationTriangle,
  faVideo,
  faImage as fasImage,
  faMoon,
  faSun,
  faCheckCircle,
  faPauseCircle,
  faCopy as fasCopy,
  faFile as fasFile,
  faPlus,
  faArchive,
  faArrowRight,
  faHome,
  faParagraph,
  faTrashAlt,
  faFilm,
  faHandPointer,
  faLanguage,
  faArrowsAltV,
  faEllipsisH,
  faCocktail,
  faEye,
  faEyeSlash,
  faClipboardList,
  faGamepad,
  faExternalLinkAlt,
  faDharmachakra,
  faMap,
  faQuestion,
  faAward,
  faFolderOpen,
  faFileAlt,
  faBars,
  faTimes,
  faBoxOpen,
  faTrophy,
  faUsersCog,
  faDesktop,
  faSignInAlt,
  faSignOutAlt,
  faMagic,
  faCalendarAlt,
  faSearch,
  faCamera,
  faCameraRetro,
  faMobileAlt,
  faFileVideo,
  faCoins,
  faClone,
  faListUl,
  faLayerGroup,
  faGem,
  faWineGlass,
  faCookie,
  faCode,
  faEnvelope,
  faColumns,
  faPen,
  faAngleDoubleLeft,
  faAngleDoubleRight,
  faSitemap,
} from '@fortawesome/free-solid-svg-icons';
import {
  faFile as farFile,
  faImage,
  faCopy,
  faAddressCard,
  faSquare,
  faCheckSquare,
  faImages,
  faListAlt,
  
} from '@fortawesome/free-regular-svg-icons';

library.add([
  faStar,
  faCog,
  faAngleUp,
  faShare,
  faHistory,
  faFont,
  faQuestionCircle,
  faUndo,
  faRedo,
  faSyncAlt,
  faExclamationTriangle,
  faVideo,
  fasImage,
  faMoon,
  faSun,
  faCheckCircle,
  faPauseCircle,
  fasCopy,
  fasFile,
  farFile,
  faImage,
  faPlus,
  faArchive,
  faArrowRight,
  faHome,
  faParagraph,
  faTrashAlt,
  faFilm,
  faHandPointer,
  faCopy,
  faLanguage,
  faArrowsAltV,
  faAddressCard,
  faSquare, 
  faCheckSquare,
  faImages,
  faEllipsisH,
  faCocktail,
  faEye,
  faEyeSlash,
  faListAlt,
  faClipboardList,
  faGamepad,
  faExternalLinkAlt,
  faDharmachakra,
  faMap,
  faQuestion,
  faAward,
  faFolderOpen,
  faFileAlt,
  faBars,
  faTimes,
  faBoxOpen,
  faTrophy,
  faUsersCog,
  faDesktop,
  faSignInAlt,
  faSignOutAlt,
  faMagic,
  faCalendarAlt,
  faSearch,
  faCamera,
  faCameraRetro,
  faMobileAlt,
  faFileVideo,
  faCoins,
  faClone,
  faListUl,
  faLayerGroup,
  faGem,
  faWineGlass,
  faCookie,
  faCode,
  faEnvelope,
  faColumns,
  faPen,
  faAngleDoubleLeft,
  faAngleDoubleRight,
  faSitemap,
]);
